import { PDFReportHeader } from './PDFReportHeader';
import { Page, Document } from '@react-pdf/renderer';
import {styles} from './PDFReportCSS'
import { PDFReportAreas } from './PDFReportArea';
import { PDFReportRemarks } from './PDFReportRemarks';
import { PDFReportSignatures } from './PDFReportSignatures';
import { PDFReportNDISQuestions } from './PDFReportNDISQuestions';
import { Report } from '../../../_models/Report.model';



interface PDFReportProps{
  currentViewingReport:Report
}

export const PDFReport:React.FC<PDFReportProps> = ({currentViewingReport}) => {



  return (
    <Document
      title={`${currentViewingReport.Client.Name} - Report`}
      author="CNA Cleaning Services"
      subject="Cleaning Report"
      creator="CNA QA System"
      producer="React PDF"
    >
      <Page size="A4" style={styles.page}>
        <PDFReportHeader client={currentViewingReport.Client} totalScore={currentViewingReport.TotalScore.toString()} reportCreateDate={currentViewingReport.ReportedDate}  />
            <PDFReportAreas client={currentViewingReport.Client} areas={currentViewingReport.Areas}/>
            <PDFReportNDISQuestions 
              client={currentViewingReport.Client} 
              NDISIncidentOccurred={currentViewingReport.NDISIncidentOccurred}
              NDISPPEUsed={currentViewingReport.NDISPPEUsed}
              NDISIncidentDetails={currentViewingReport.NDISIncidentDetails}
            />
            <PDFReportRemarks client={currentViewingReport.Client} CNARemarks={currentViewingReport.CNARemarks} ClientRemarks={currentViewingReport.ClientRemarks}/>
            <PDFReportSignatures  Client={currentViewingReport.Client} CNASignature={currentViewingReport.QASignature} ClientSignature={currentViewingReport.ClientSignature} ClientConcent={currentViewingReport.ClientConcent} InspectedBy={currentViewingReport.InspectedBy}  />
      </Page>
    </Document>
  );
};

